import { render, staticRenderFns } from "./PriceSpecial.vue?vue&type=template&id=15dbd161&scoped=true&"
import script from "./PriceSpecial.vue?vue&type=script&lang=js&"
export * from "./PriceSpecial.vue?vue&type=script&lang=js&"
import style0 from "./PriceSpecial.vue?vue&type=style&index=0&id=15dbd161&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15dbd161",
  null
  
)

export default component.exports